import { Box, IconNewOptions, TextNew } from '@jfs/ui-new'
import { ButtonNew } from '../AdminButton'
import { isEmpty } from '@jfs/utils'
import { styles } from './index'

export const ActionButton = ({ type, label, onAction, isLoading }: any) => {
  const color: any = {
    edit: 'YELLOW',
    delete: 'RED',
    mapping: 'GREEN',
  }
  if (isEmpty(label)) {
    return <TextNew {...styles.labelStyle} color={'BLACK_21'} numberOfLines={1} title={'NA'} />
  }
  return (
    <Box marginHorizontal={16}>
      <ButtonNew
        icon={type.toString().toUpperCase() as IconNewOptions}
        type="primaryIcon"
        borderColor="WHITE"
        title={label}
        onPress={onAction}
        height={32}
        width={type === 'edit' ? 80 : 86}
        hoverColor={color[type] ?? 'BLUE'}
        borderRadius={4}
        underlayColor={color[type] ?? 'BLUE'}
        color={color[type] ?? 'BLUE'}
        isLoading={isLoading}
      />
    </Box>
  )
}
